import React, { useState, useRef, useEffect } from 'react';
import { trackPixelEvent } from '../../utils/pixel';

const DropdownButton = ({ title, options, selectedOption, setSelectedOption, onOptionSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown visibility
  const toggleDropdown = () => setIsOpen(!isOpen);

  // Handle option click
  const handleOptionClick = (option) => {
    trackPixelEvent("ClickDropdown")
    setSelectedOption(option);
    if (onOptionSelect) {
      onOptionSelect(option);
    }
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  // Update selected option when options change but keep the selected key
  useEffect(() => {
    const currentOption = options.find(opt => opt.key === selectedOption.key);
    if (currentOption) {
      setSelectedOption(currentOption);
    }
  }, [options]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left w-36 sm:w-40 md:w-44 flex-shrink" ref={dropdownRef}>
      <div className="mb-1 text-xs text-gray-800 font-semibold">{title}</div>
      <button
        onClick={toggleDropdown}
        className={`w-full min-w-0 px-4 py-2 rounded-3xl shadow-md focus:outline-none flex items-center justify-between ${
          selectedOption && selectedOption.key === options[0].key ? 'bg-beige' : 'bg-brown'
        } text-white`}
      >
        <span className="min-w-0">{selectedOption ? selectedOption.name : 'Select an option'}</span>
        <svg className="w-4 h-4 ml-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>
      {isOpen && (
        <ul className="absolute left-0 right-0 bg-white opacity-100 border rounded-lg shadow-lg min-w-full z-20 cursor-pointer mt-2">
          {options.map((option) => (
            <li key={option.key} className="hover:text-black">
              <a
                onClick={() => handleOptionClick(option)}
                className={`block px-4 py-2 rounded ${
                  selectedOption && selectedOption.key === option.key ? 'bg-beige text-white' : ''
                }`}
              >
                {option.name}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropdownButton;
